export default {
    lang: {
        name: 'Game name'
    }
}